import { scoreColor, priorityStyles } from "@/lib/format";

export function ScoreRing({ score, size = 84, label = "" }) {
  const stroke = 7;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const off = c - (score / 100) * c;
  const color = scoreColor(score);
  return (
    <div className="relative grid place-items-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="hsl(217 33% 16%)" strokeWidth={stroke} />
        <circle
          cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
          strokeDasharray={c} strokeDashoffset={off} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset .9s cubic-bezier(.16,.84,.44,1)" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center leading-none">
        <span className="font-display font-bold lf-tabnum" style={{ color, fontSize: size * 0.3 }}>
          {score}
        </span>
        {label && <span className="text-[9px] font-mono uppercase tracking-wider text-slate-500 mt-0.5">{label}</span>}
      </div>
    </div>
  );
}

export function PriorityBadge({ label, testid }) {
  const s = priorityStyles(label);
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 text-[10px] font-mono font-semibold uppercase tracking-wider px-2.5 py-1 rounded-md ${s.bg} ${s.text} border ${s.border}`}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.dot }} />
      {label}
    </span>
  );
}
